/**
 * Catálogos DIAN mínimos, solo lo que la aplicación necesita en memoria; los grandes, como DIVIPOLA
 * completo, viven en la base. Fuente: `docs/research/normativa-dian.md`.
 */
import type { MetodoPago } from './tipos';

/**
 * Dónde aplica cada tipo de documento. `autoregistro` deja fuera el registro civil y la tarjeta de
 * identidad, de menores que ahí se registrarían solos; en el mostrador siguen disponibles.
 */
export type ContextoDocumento = 'cliente' | 'autoregistro' | 'proveedor' | 'titular_negocio' | 'representante';

export const TIPOS_DOCUMENTO_DIAN: {
  codigo: string;
  nombre: string;
  contextos: ContextoDocumento[];
}[] = [
  { codigo: '11', nombre: 'Registro civil', contextos: ['cliente'] },
  { codigo: '12', nombre: 'Tarjeta de identidad', contextos: ['cliente'] },
  { codigo: '13', nombre: 'Cédula de ciudadanía', contextos: ['cliente', 'autoregistro', 'proveedor', 'titular_negocio', 'representante'] },
  { codigo: '21', nombre: 'Tarjeta de extranjería', contextos: ['cliente', 'autoregistro', 'titular_negocio', 'representante'] },
  { codigo: '22', nombre: 'Cédula de extranjería', contextos: ['cliente', 'autoregistro', 'proveedor', 'titular_negocio', 'representante'] },
  { codigo: '31', nombre: 'NIT', contextos: ['cliente', 'autoregistro', 'proveedor'] },
  { codigo: '41', nombre: 'Pasaporte', contextos: ['cliente', 'autoregistro', 'titular_negocio', 'representante'] },
  { codigo: '42', nombre: 'Documento de identificación extranjero', contextos: ['cliente', 'autoregistro'] },
  { codigo: '48', nombre: 'Permiso por Protección Temporal (PPT)', contextos: ['cliente', 'autoregistro', 'titular_negocio', 'representante'] },
];

export const CONSUMIDOR_FINAL = {
  tipoDocumento: '13',
  numeroDocumento: '222222222222',
  nombre: 'consumidor final',
} as const;

/**
 * Medios de pago del anexo técnico (UNCL4461) para micronegocio; los consume solo `proveedor-fe/`.
 * En la venta el código DIAN sale de `cuentas_negocio.medio_pago_dian`, no de esta tabla.
 */
export const MEDIOS_PAGO_DIAN: Record<MetodoPago, { codigo: string; nombre: string }> = {
  efectivo: { codigo: '10', nombre: 'Efectivo' },
  tarjeta: { codigo: '48', nombre: 'Tarjeta crédito/débito' },
  nequi: { codigo: '47', nombre: 'Transferencia débito bancaria' },
  daviplata: { codigo: '47', nombre: 'Transferencia débito bancaria' },
  breb: { codigo: '45', nombre: 'Transferencia crédito bancaria' },
  transferencia: { codigo: '45', nombre: 'Transferencia crédito bancaria' },
  otro: { codigo: 'ZZZ', nombre: 'Otro' },
};

/** UVT por año (Res. DIAN de cada diciembre). Actualizar en diciembre — ver docs/10 §4. */
const UVT_ANUAL: Record<number, number> = {
  2024: 47065,
  2025: 49799,
  2026: 52374,
};

export function umbralNoObligadoCOP(anio: number): number | undefined {
  const uvt = UVT_ANUAL[anio];
  return uvt ? uvt * 3500 : undefined;
}
